import Popup from "devextreme-react/popup"
import React, {useCallback, useEffect, useRef, useState} from "react"
import notify from "devextreme/ui/notify"
import {PopupTitleWithIcon} from "../popup-title-with-icon/popup-title-with-icon";
import {faRefresh} from "@fortawesome/free-solid-svg-icons";
import ScrollView from "devextreme-react/scroll-view";
import SixDigitInput from "../six-digit-input/six-digit-input";
import {Button} from "devextreme-react/button";
import {generateFingerpint, sendPhoneCode, getUser} from "../../api/auth";
import {useHistory} from "react-router-dom";
import StorageService from "../../services/storage.service";
import {useAuth} from "../../contexts/auth";
import {setCookie, getCookie, deleteCookie} from "../../utils/cookie";

export const smsTimerCookieNames = (typeOp) => ({
    start: `timerStart_${typeOp}`,
    expires: `timerStartExpires_${typeOp}`,
})

export const formatSmsCountdown = (remaining) => {
    if (!remaining || remaining <= 0) return ''
    const minutes = Math.floor(remaining / 60)
    const seconds = remaining % 60
    return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
}

export const readSmsTimerRemaining = (typeOp) => {
    const {expires, start} = smsTimerCookieNames(typeOp)
    const storedExpire = getCookie(expires)
    if (!storedExpire) return 0
    const remainingMs = parseInt(storedExpire, 10) - Date.now()
    if (remainingMs > 0) return Math.ceil(remainingMs / 1000)
    deleteCookie(start)
    deleteCookie(expires)
    return 0
}

export const useSmsTypeOpTimer = (typeOp) => {
    const [remaining, setRemaining] = useState(() => readSmsTimerRemaining(typeOp))
    useEffect(() => {
        const tick = () => setRemaining(readSmsTimerRemaining(typeOp))
        tick()
        const id = setInterval(tick, 1000)
        return () => clearInterval(id)
    }, [typeOp])
    return remaining
}

const SmsPopupDifferent = ({typeOp, formData, messageSendSms, timerStart, setTimerStart, lifeTimeSeconds, setLifeTimeSeconds, uid, authSettings, selectedValueRadio}  ) => {
    const history = useHistory();
    const [time, setTime] = useState(null)
    const [digitCode, setDigitCode] = useState('');
    const { syncUserData, setAuth, setCountDogovors, setUser, user } = useAuth();
    const [visiblePopup, setVisiblePopup] = useState(false);
    const [isCodeValid, setIsCodeValid] = useState(false);
    const {start: cookieTimerStart, expires: cookieTimerExpires} = smsTimerCookieNames(typeOp)

    const lastStartedTypeOpRef = useRef(null);
    const timerIdRef = useRef(null);

    const applyRemaining = useCallback((remaining) => {
        setLifeTimeSeconds(remaining)
        setTime(remaining > 0 ? formatSmsCountdown(remaining) : null)
    }, [setLifeTimeSeconds]);

    const clearIntervalFunc = useCallback(() => {
        if (timerIdRef.current) {
            clearInterval(timerIdRef.current);
            timerIdRef.current = null;
        }
        setTimerStart(false)
        setVisiblePopup(false)
        applyRemaining(0)
        lastStartedTypeOpRef.current = null
        deleteCookie(cookieTimerStart);
        deleteCookie(cookieTimerExpires);
    }, [applyRemaining, setTimerStart, cookieTimerStart, cookieTimerExpires]);

    const timerRun = useCallback((duration, writeCookies = true) => {
        if (writeCookies) {
            const expirationTime = Date.now() + duration * 1000;
            setCookie(cookieTimerExpires, expirationTime.toString(), {
                expires: new Date(expirationTime),
                path: '/'
            });
            setCookie(cookieTimerStart, 'true', {
                expires: new Date(expirationTime),
                path: '/'
            });
        }
        let remaining = duration;
        applyRemaining(remaining)
        timerIdRef.current = setInterval(() => {
            if (--remaining < 0) {
                //console.log('clear')
                clearIntervalFunc();
                return
            }
            //console.log(time)
            applyRemaining(remaining)
        }, 1000);
    }, [applyRemaining, clearIntervalFunc, cookieTimerStart, cookieTimerExpires]);

    useEffect(() => {
        const typeOpKey = String(typeOp)
        const shouldStartNew = timerStart && lastStartedTypeOpRef.current !== typeOpKey

        if (!timerStart) {
            lastStartedTypeOpRef.current = null
        }

        if (shouldStartNew) {
            lastStartedTypeOpRef.current = typeOpKey
            const authSeconds = (authSettings?.errorLoginLockMinute || 0) * 60
            if (authSeconds > 0) {
                setVisiblePopup(true);
                timerRun(authSeconds);
            }
        } else if (!timerIdRef.current) {
            const remaining = readSmsTimerRemaining(typeOp)
            if (remaining > 0) {
                applyRemaining(remaining)
                timerRun(remaining, false);
            } else {
                applyRemaining(0)
            }
        }

        return () => {
            if (timerIdRef.current) {
                clearInterval(timerIdRef.current);
                timerIdRef.current = null;
            }
        };
    }, [timerRun, timerStart, typeOp, authSettings?.errorLoginLockMinute, applyRemaining]);

    const handleCodeChange = (value, isValid) => {
        setDigitCode(value);
        setIsCodeValid(isValid);
    };

    const onBtnSendCodeSMS = async () => {
        try {
            const fingerprint = await generateFingerpint()
            const res = await sendPhoneCode(digitCode, '+7' + formData.phone, uid, typeOp, fingerprint, user?.id)
            if (res.isOk && res.isNew && typeOp === 0) {
                clearIntervalFunc();
                history.push({
                    pathname: '/create-account',
                    state: {
                        from_phone_auth:true,
                      phone: formData.phone,
                      email:'',
                      first_name:'',
                      last_name:'',
                      inn:'',
                      uid: uid
                    },
                  });

            } else if (res.isOk && !res.isNew  && typeOp === 1) {
                clearIntervalFunc();
                StorageService.setLocalAuth(fingerprint)
                setAuth(res)
                setCountDogovors(res.dogovors)
                await syncUserData();
            } else if (res.isOk && typeOp === 2) {
                clearIntervalFunc();
                notify(res.message, 'success', 5000)
                const freshUser = await getUser();
                if (freshUser.isOk) setUser(freshUser.data);
                await syncUserData();
            } else if (!res.isOk) {
                notify(res.message, 'error', 5000)
            }
        } catch (e) {
            notify(e.message, 'error', 5000)
        }
    }

    const hidePop = () => {
        setVisiblePopup(false)
    }
    return (
        <>

            {!!lifeTimeSeconds && selectedValueRadio &&
                <div className='text-center p-3'>Новый код можно запросить<br/>через <span className="timeCountDown">{time}</span> мин.</div>
            }

            <Popup visible={visiblePopup}
                   showCloseButton={false}
                   showTitle={true}
                   title={'Введите код из СМС'}
                   maxWidth={350}
                   maxHeight={'90%'}
                   height={'auto'}
                   onHiding={hidePop}
                   titleRender={()=>PopupTitleWithIcon(faRefresh, 'Введите код из СМС',hidePop)}
            >
                <ScrollView className="big-input" width='100%' height='100%'>
                    <div className='row big-input big-input-bold'>
                        <div className='col-12 text-center'>
                            <h5>{messageSendSms}</h5>
                            <SixDigitInput
                                onValueChange={handleCodeChange} numberOfDigits={5}
                                initialValue=""
                                onBtnSendCodeSMS ={onBtnSendCodeSMS}
                            />
                        </div>
                        <div className='col-12'>
                            <div className='text-center p-3'>Новый код можно запросить<br/>через <span className="timeCountDown">{time}</span> мин.</div>
                            <Button className={'btn-block'} id="button"
                                    text={`Отправить`}
                                    type="default"
                                    stylingMode="contained"
                                    onClick={onBtnSendCodeSMS}
                                    disabled={!isCodeValid}

                            />
                        </div>
                    </div>
                </ScrollView>
            </Popup>
        </>
    )
}

export default SmsPopupDifferent
